import {
  Activity, Users, Clock, TrendingUp,
  ShieldCheck, Zap, BarChart3, Wallet
} from 'lucide-react';

const benefits = [
  {
    icon: Users,
    title: 'More Patients, Consistently',
    description: 'Our marketing systems deliver a steady flow of new patient appointments month after month.',
  },
  {
    icon: TrendingUp,
    title: '3x Practice Growth',
    description: 'Clinics using our full suite see up to 3x increase in patient footfall within 6 months.',
  },
  {
    icon: ShieldCheck,
    title: 'Stronger Online Reputation',
    description: 'Build a 5-star presence across Google, Practo, and Healthgrades that patients trust instantly.',
  },
  {
    icon: Clock,
    title: 'Save 15+ Hours/Week',
    description: 'Stop juggling marketing, social media, and paperwork. We handle it all — you focus on care.',
  },
  {
    icon: Zap,
    title: 'AI Assistant On Your Website',
    description: 'A built-in AI handles enquiries, provides info, and books appointments — even when your clinic is closed.',
  },
  {
    icon: Activity,
    title: 'Higher Search Visibility',
    description: 'Rank at the top of Google, Bing, and even ChatGPT when patients search for your specialty.',
  },
  {
    icon: BarChart3,
    title: 'Transparent ROI Tracking',
    description: 'Monthly performance reports with clear metrics — you always know exactly what you are getting.',
  },
  {
    icon: Wallet,
    title: 'SEO That Actually Works',
    description: 'Rank at the top of Google for your specialty — locally and nationally — with proven SEO strategies.',
  },
];

const Benefits = () => (
  <section className="bg-[#F9F7F2] py-20 lg:py-28" data-testid="benefits-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-14">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#8C6330] mb-4">Why It Works</p>
        <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight text-[#11181C]">
          Real Benefits for Your Practice
        </h2>
        <p className="text-base text-[#4A5568] mt-3 max-w-xl mx-auto">
          Every service we offer is designed with one goal — measurable growth for your clinic.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {benefits.map((b, i) => (
          <div
            key={b.title}
            className="bg-white border border-[#D6CEBF] rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 service-card"
            data-testid={`benefit-item-${i}`}
          >
            <div className="w-10 h-10 rounded-xl bg-[#D4E4DA] flex items-center justify-center mb-4">
              <b.icon size={20} className="text-[#1B3F33]" />
            </div>
            <h3 className="font-heading text-base font-medium text-[#11181C] mb-2">{b.title}</h3>
            <p className="text-sm text-[#4A5568] leading-relaxed">{b.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Benefits;
